import ns from '@mdz/mirador/dist/es/src/config/css-ns'
import CollectionInfo from '@mdz/mirador/dist/es/src/containers/CollectionInfo'
import CompanionWindow from '@mdz/mirador/dist/es/src/containers/CompanionWindow'
import LocalePicker from '@mdz/mirador/dist/es/src/containers/LocalePicker'
import ManifestInfo from '@mdz/mirador/dist/es/src/containers/ManifestInfo'
import ManifestRelatedLinks from '@mdz/mirador/dist/es/src/containers/ManifestRelatedLinks'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

/**
 * Customized WindowSidebarInfoPanel that removes the canvas information,
 * otherwise identical to the upstream WindowSidebarInfoPanel component.
 *
 * Upstream code was taken from here: https://github.com/ProjectMirador/mirador/blob/v3.3.0/src/components/WindowSideBarInfoPanel.js
 */
export default class MdzWindowSideBarInfoPanel extends Component {
  /**
   * render
   * @return
   */
  render() {
    const {
      windowId,
      id,
      classes,
      collectionPath,
      t,
      locale,
      setLocale,
      availableLocales,
      showLocalePicker,
    } = this.props

    return (
      <CompanionWindow
        title={t('aboutThisItem')}
        paperClassName={ns('window-sidebar-info-panel')}
        windowId={windowId}
        id={id}
        titleControls={
          showLocalePicker && (
            <LocalePicker
              locale={locale}
              setLocale={setLocale}
              availableLocales={availableLocales}
            />
          )
        }
      >
        {collectionPath.length > 0 && (
          <div className={classes.section}>
            <CollectionInfo id={id} windowId={windowId} />
          </div>
        )}

        <div className={classes.section}>
          <ManifestInfo id={id} windowId={windowId} />
        </div>

        <div className={classes.section}>
          <ManifestRelatedLinks id={id} windowId={windowId} />
        </div>
      </CompanionWindow>
    )
  }
}

MdzWindowSideBarInfoPanel.propTypes = {
  availableLocales: PropTypes.arrayOf(PropTypes.string),
  canvasIds: PropTypes.arrayOf(PropTypes.string),
  classes: PropTypes.objectOf(PropTypes.string),
  collectionPath: PropTypes.arrayOf(PropTypes.string),
  id: PropTypes.string.isRequired,
  locale: PropTypes.string,
  setLocale: PropTypes.func,
  showLocalePicker: PropTypes.bool,
  t: PropTypes.func,
  windowId: PropTypes.string.isRequired,
}

MdzWindowSideBarInfoPanel.defaultProps = {
  availableLocales: [],
  canvasIds: [],
  classes: {},
  collectionPath: [],
  locale: '',
  setLocale: undefined,
  showLocalePicker: false,
  t: (key) => key,
}
